module.exports = __webpack_public_path__ + "static/c4-15908a9c27fc59d0dd50fffa13cff08a.webp";